<header class="d-flex align-items-center">
    <span>
        Selecione o tipo <span *ngIf="requiredIndicator">*</span>
    </span>
    <app-tooltip-mat
        class="d-flex ms-2"
        typeInformation="text"
        text="Escolha se deseja fazer o upload de um arquivo (imagem ou PDF) ou direcionar para um link externo."
        type="info-banner"></app-tooltip-mat>
</header>
<div class="d-block mt-2">
    <mat-radio-group class="attachment-type-control" [formControl]="attachmentTypeControl">
        <mat-radio-button [value]="'FILE'">
            Arquivo (Imagem ou PDF)
        </mat-radio-button>
        <mat-radio-button [value]="'URL'">
            Link externo
        </mat-radio-button>
    </mat-radio-group>
</div>
<div class="d-block mt-4" *ngIf="attachmentTypeControl.value === 'FILE'">
    <section class="image-uploader">
        <div class="image-uploader-container" *ngIf="!fileUrlControl.value">
            <input
                type="file"
                ng2FileSelect
                value=""
                [uploader]="contentUploader"
                id="upload-input-content"
                class="d-none"
                name="fileContentUploader"
                accept=".png, .jpeg, .pdf"
            />
            <label class="label-upload-input w-100" for="upload-input-content">
                <div
                    ng2FileDrop
                    [ngClass]="{ 'nv-file-over': hasBaseDropZoneOverContent }"
                    (fileOver)="fileOverBaseContent($event)"
                    [uploader]="contentUploader"
                    class="well file-upload-drop-zone">
                    <div class="file-upload-drop-zone-contents">
                        <i class="fa fa-cloud-upload" aria-hidden="true"></i><br/>
                        <span>
                            Clique para fazer <strong>upload</strong>
                        </span>
                    </div>
                </div>
            </label>
            <div class="help-block">
                <small>
                    Tamanho máximo: 2MB. Arquivos aceitos: .PNG, .JPEG e .PDF
                </small>
            </div>
        </div>
        <div *ngIf="fileUrlControl.value" class="image-uploader-preview">
            <div class="image-uploader-preview-container col-md-6 col-sm-12">
                <img
                    *ngIf="!isPdfAttachment"
                    [src]="fileUrlControl.value | sanitizeURL"/>
                <iframe
                    *ngIf="isPdfAttachment"
                    [src]="fileUrlControl.value | sanitizeURL"
                    width="100%"
                    height="100%">
                </iframe>
                <div class="btn-remove-preview">
                    <button type="button" (click)="removeAttachment()">
                        <i class="fal fa-trash-alt"></i>
                        REMOVER
                    </button>
                </div>
            </div>
        </div>
    </section>
</div>
<div class="d-block mt-4" *ngIf="attachmentTypeControl.value === 'URL'">
    <mat-form-field>
        <mat-label>URL *</mat-label>
        <input
            matInput
            type="text"
            placeholder="https://exemplo.com.br"
            [formControl]="urlControl" />
        <app-tooltip-mat
            matSuffix
            class="icon-url"
            typeInformation="text"
            text="Exemplo: https://flowing.com.br"
            type="info-banner"></app-tooltip-mat>
        <mat-hint>
            Insira uma URL para uma página da web ou um vídeo.
        </mat-hint>
        <mat-error *ngIf="urlControl.errors?.required">
            Este campo é obrigatório
        </mat-error>
        <mat-error *ngIf="urlControl.errors?.patternLink">
            Informe uma URL válida (com https)
        </mat-error>
    </mat-form-field>
</div>
